module.exports = globalThis["crateImports"]["@xing-com/crate-xinglet"];